import React, { Component } from 'react';
import { ThemeContext } from '../../../Themes/ThemeContext';
import { turnColors } from '../../../Utils/ColorUtil';
import isInsignia from '../../../Utils/IsInsignia'
import rblHeaderLogo from '../../../../assets/imgs/rbl_header_logo.svg'
import arrowUp from '../../../../assets/imgs/icons/arrow-up.png';
import insigniaLogo from '../../../../assets/imgs/insignia-logo.svg'
import logOutIcon from '../../../../assets/imgs/logout.svg';
import rblBankLogo from '../../../../assets/imgs/rbl-bank-logo.svg';

interface IProps{
    botName
    toggleOverlay,
    toggleChatBody,
    isChatBodyVisible,
    hideBot,
    data,
    handleModalToggle ? ,
    handleLogout ?,
    isLoggedIn,
    theme ?,
    redirectToExternalBot,
    logoImagePath,
    isPushBotVisible,
    netbanking,
    isBotVisible,
    isSessionExpire?
}

/**
 *
 *     background-image: linear-gradient(to left, rgb(186, 68, 25), rgb(240, 131, 92) 75%, rgb(245, 151, 106) 96%);
     background: rgb(186, 68, 25); 
     background: rgb(228, 141, 110);  
 * 
 */

//background : ${props.styles.primaryColor == "#56a0d3" ? "linear-gradient(72deg, #1e4388, #56a0d3)" : isInsignia()? '#070d44':'radial-gradient(circle at 100% 130%, #ae0105, #2e0202)'}
//OverRide the css..
const HeaderStyles = (props) => {
    //props.styles.primaryColor = "#0267f0";
    return(
        <style dangerouslySetInnerHTML={{__html: `
        .sf-header{
            /*color: ${props.styles.primaryColor};*/
            background : ${props.styles.primaryColor == "#56a0d3" ? "linear-gradient(72deg, #1e4388, #56a0d3)" : isInsignia()? '#070d44':'radial-gradient(circle at 100% 130%, #ae0105, #2e0202)'}
        
        }
            `}}
            />
            )
        }
        
const styleFromTheme = (props) => {
    switch(props.theme){
        case "Theme1" : {
            return null
        }
        case "Theme2" : {
            return null
        }
        case "Theme3" : {
            var primaryColor = props.data.primaryColor;
            //return {backgroundImage : "linear-gradient(to left, #bd471c, #ec7f57 75%, #f59669 96%)"};
            return {backgroundImage : `linear-gradient(to left, 
                        ${primaryColor} , 
                        ${turnColors(primaryColor,{r:54,g:63,b:67})} 75%,
                        ${turnColors(primaryColor,{r:58,g:78,b:78})} 96%
                    )`}
        }
        default : {
            return null
        }
    }
    //return props.theme ? {backgroundImage : "linear-gradient(to left, #bd471c, #ec7f57 75%, #f59669 96%)"} : null
 }       

class Header extends Component<IProps,null> {
    constructor(props){
        super(props);
        this['contextTheme'] = props['context'];
    }
    checkIfExternalLinkRequired() {
        var url = window.location.pathname;
        if (
            url === '/chatsdk.html' && 
            window.location.origin != 'http://ec2-13-233-208-207.ap-south-1.compute.amazonaws.com' &&
            window.location.origin != 'https://aware.senseforth.com' && 
            window.location.origin != 'http://aware.senseforth.com'
        ) {
            return false;
        }
        return true;
    }

    isURLAbsolute(url){
        return url.includes("http")
    }

    render() {
        
        let contextTheme = this['contextTheme'];
        let isTheme = !!this.props.theme;
        return (
            <div className="sf-header" style={isTheme ? styleFromTheme(this.props): {}} >
                <HeaderStyles styles={contextTheme}/>
                <div className="header-title-wrapper">
                    <div className="torso header-torso"
                        //#TODO: make it dynamic style={{
                        //     background: this.isURLAbsolute(this.props.data.logoImagePath) ? `url('${this.props.data.logoImagePath}')` : `url('${window['SF_BASE_URL']+this.props.data.logoImagePath}')`,
                        //     backgroundSize:"contain", backgroundRepeat:"no-repeat",backgroundPosition: 'center'
                        // }}
                    >
                    {isInsignia() && <img style={{width:'auto',height:'auto',marginRight:'10px'}} src={insigniaLogo} alt="insignia logo"/>}
                    <img src={rblHeaderLogo || this.props.logoImagePath} alt="rbl logo"/>
                    </div>
                    {/* <div className="header-title">{this.props.botName}</div> */}
                </div>
          
                {window.location.href.includes('pb/RBLCares') || this.props.isPushBotVisible?  
                    <div className="header-btn-wrapper">
                    <div className={`header-btns bank-logo`}>
                        <img  style={{width:'100px', height:'60px', marginRight: "-6px"}} src={rblBankLogo} alt="rbl bank logo"/>
                    </div>
                    {this.props.isLoggedIn && !this.props.netbanking &&
                                <div title={'logout'} className={`header-btns header-logout-icon`}>
                                    <img src={logOutIcon} onClick={()=>this.props.handleLogout(true)}  alt="log out Icon"/>
                                </div>
                    }
                    </div>
                    :
                            <div className="header-btn-wrapper">
                            {this.props.data.isInsideAware == true ? <div className="header-btns expand"
                                onClick={this.props.redirectToExternalBot}
                            >
                            </div> : ""}
                            
                            <div className="header-btns header-offers" onClick={this.props.toggleOverlay}
                                style={{display: this.props.isChatBodyVisible ? "" : "none"}}
                                >
                                <div className="offers-notification"></div>
                            </div>
                            
                            {/* {((window.location.href.includes('pb/RBLCares') || this.props.isPushBotVisible) && this.props.isLoggedIn)?  */}
                            {/* {(this.props.isPushBotVisible==true && this.props.isLoggedIn)? 
                                <div title={'logout'} className={`header-btns header-logout-icon`}>
                                    <img src={logOutIcon} onClick={()=>this.props.handleLogout(true)} alt="log out Icon"/>
                                </div>
                            :null
                            } */}

                            {this.props.isLoggedIn && !this.props.netbanking &&
                                <div title={'logout'} className={`header-btns header-logout-icon`}>
                                    <img src={logOutIcon} onClick={!this.props.netbanking?()=>this.props.handleLogout(true):null} alt="log out Icon"/>
                                    {/* <img src={logOutIcon} alt="log out Icon"/> */}
                                </div>
                            }
                            {/* here */}
                            <div className={`header-btns ${this.props.isChatBodyVisible ? "minimize-arrow-downleft" : "minimize-arrow-upright"} `}
                                    onClick={this.props.toggleChatBody}>
                                {!this.props.isChatBodyVisible &&<img src={arrowUp} alt="up arrow"/>}
                            </div>
                            <div className="header-btns minimize-minus"
                                onClick={this.props.handleModalToggle? this.props.handleModalToggle : this.props.hideBot}
                            >
                            </div>
                        </div>
                    }
            </div>
        );
    }
}

Header['contextType'] = ThemeContext;

export default (props) => <ThemeContext.Consumer>{
        context => <Header {...props}  context={context}/>
    }
    </ThemeContext.Consumer>